<form class="ui form auth-form" #exchangeOnPremForm="ngForm" (submit)="handleSubmit(user)">
    <div class="ui centered card">
        <div class="content left aligned title">
            <img class="mini ui image" src="/assets/images/partners/exchange.png" alt="Microsoft Exchange logo" />
            <div class="header">{{ title }}</div>
        </div>
        <div class="content center aligned">
            <div class="two fields">
                <div class="field">
                    <input
                        [(ngModel)]="user.email"
                        #email="ngModel"
                        type="email"
                        name="email"
                        placeholder="Email"
                        autocomplete="off"
                        required
                        email
                    />
                    <div *ngIf="email.invalid && email.touched" class="form__warning">Please enter a valid email.</div>
                </div>
                <div *ngIf="requiresPassword" class="field">
                    <input
                        [(ngModel)]="user.password"
                        #password="ngModel"
                        type="password"
                        name="password"
                        placeholder="Password"
                        autocapitalize="none"
                        required
                        password
                    />
                    <div *ngIf="password.invalid && password.touched" class="form__warning">
                        Please enter your password.
                    </div>
                </div>
            </div>
            <div class="ui error text" *ngIf="hasError">Please fill in missing details.</div>
        </div>
        <div class="content right aligned bottom">
            <div class="buttons">
                <button type="submit" class="ui primary button right-floated sign-in">Sign In</button>
                <button class="ui button right-floated cancel" (click)="handleCancelForm()">Cancel</button>
            </div>
        </div>
    </div>
</form>
